// import Loader from "react-loader-spinner";
import { Spinner } from "react-bootstrap";

export const UploadSpinner = () => {
  return <Spinner animation="border" size="sm" variant="info" role="status" aria-hidden="true" />;
};
